
import React from "react";

const CodeBlocks = () => {

    return (

        <div id={"code-blocks"}>

            <h3 id="blocks">Code Blocks</h3>
            <div className={"imageContainer"}>
                <img src="/images/code_blocks.png" alt="App Actions" />
            </div>

            <div>
                <p>
                    The <strong>Custom JavaScript</strong> block allows you to write and run your own JavaScript code directly within Blockly.
                    This is useful when the functionality you need is not already provided by the existing blocks.
                </p>

                <p>
                    You can define a custom function and pass in parameters using JSON key-value pairs. This makes it easy to send structured data into your function.
                </p>

            </div>

        </div>

    )
}

export default CodeBlocks; 
